export default __webpack_public_path__ + "static/media/Frame 2.a0ebf772.jpg";